import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { getDefaultFilters } from './filter.defaults';
import {
  FavoritesListLeastRecent,
  FavoritesListMostRecent,
  FavoritesListState,
  ListDirection,
  listingDirections,
  ListWindowLoaderStateType,
} from './list.types';
import { FavoritesSort, isFavoritesort } from './filter.types';
import { filtersHash } from '../hooks/useFavoritesFiltersIdentifier';

export const defaults = {
  most_recent: (): {
    type: SortOptionsEnum.MOST_RECENT;
    data: FavoritesListMostRecent;
  } => ({
    type: SortOptionsEnum.MOST_RECENT,
    data: {
      __typename: SortOptionsEnum.MOST_RECENT,
      lastScrollPosition: 0,
      detailedToListedStartOffset: 0,
      cursor: [
        { publishedDate: '1000-01-01T00:00:00.000000+00:00', artistContextId: 0, artworkId: 0 },
        { publishedDate: '4000-01-01T00:00:00.000000+00:00', artistContextId: 0, artworkId: 0 },
      ],
      listed: {
        batchSize: 64,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
      detailed: {
        batchSize: 16,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
    },
  }),
  least_recent: (): {
    type: SortOptionsEnum.LEAST_RECENT;
    data: FavoritesListLeastRecent;
  } => ({
    type: SortOptionsEnum.LEAST_RECENT,
    data: {
      __typename: SortOptionsEnum.LEAST_RECENT,
      lastScrollPosition: 0,
      detailedToListedStartOffset: 0,
      cursor: [
        { publishedDate: '4000-01-01T00:00:00.000000+00:00', artistContextId: 0, artworkId: 0 },
        { publishedDate: '1000-01-01T00:00:00.000000+00:00', artistContextId: 0, artworkId: 0 },
      ],
      listed: {
        batchSize: 64,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
      detailed: {
        batchSize: 16,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
    },
  }),
};
const defaultFilters = getDefaultFilters();

export const getDefaultListState: () => FavoritesListState = () => {
  const currentSort: FavoritesSort = isFavoritesort(defaultFilters.currentSort)
    ? defaultFilters.currentSort
    : SortOptionsEnum.MOST_RECENT;

  return {
    identifier: filtersHash(defaultFilters),
    ...defaults[currentSort](),
  };
};

export const listInitialState = getDefaultListState();

export const hasMore = (loader: ListWindowLoaderStateType<unknown, unknown>, direction: ListDirection): boolean =>
  loader.hasMore[listingDirections.indexOf(direction)];
